<template>
    <div>
       财务模组
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
